import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { PhotosReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const photosReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...PhotosReducerHandlers.fetchPhotosAndResources,
    ...PhotosReducerHandlers.addPhotoByProjectId,
    ...PhotosReducerHandlers.addMultiplePhotos,
    ...PhotosReducerHandlers.updateMultiplePhotos,
    ...PhotosReducerHandlers.updatePhoto,
    ...PhotosReducerHandlers.deletePhotoWithIndexShifting,
    ...PhotosReducerHandlers.sendPhotosUploadInfo,
    ...PhotosReducerHandlers.replaceCoverPhoto,
    ...PhotosReducerHandlers.chooseCoverPhoto,
    ...PhotosReducerHandlers.getCoverPhotosByProjectId,
    ...PhotosReducerHandlers.getCoverPhotos,
    ...PhotosReducerHandlers.deleteCoverPhotos,
    ...PhotosReducerHandlers.addCoverPhoto,
  },
);

export default photosReducer;
